import React from 'react';

import { useFeatureFlagContext } from 'Contexts/featureFlagContext';
import { Paragraph } from 'DesignLibrary/atoms';

import { FooterContainer } from './styled';
import { PRIVACY_POLICY_URL, TERMS_OF_SERVICE } from '../../../constants';

export interface FooterProps {
  isNextClicked: boolean;
}

export const Footer = () => {
  const { is_footer_test_enabled } = useFeatureFlagContext();
  const currentYearString = `${new Date().getFullYear()}${is_footer_test_enabled ? ' |' : ''}`;

  return (
    <FooterContainer isNextClicked={false}>
      <Paragraph size="mini">
        <span>
          &copy; 2008–{currentYearString} The Jellyvision Lab, Inc. All rights reserved.
          <span className="separator">|</span>
          <a href={PRIVACY_POLICY_URL} target="_blank" rel="noreferrer">
            Privacy Policy
          </a>
          <span className="separator">|</span>
          <a href={TERMS_OF_SERVICE} target="_blank" rel="noreferrer">
            Terms of Service
          </a>
        </span>
      </Paragraph>
    </FooterContainer>
  );
};
